import apiClient from './authService';

export function getBusinessSetupData(businessId) {
  return apiClient
    .get(`/business/${businessId}/setup-data/`)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to fetch business setup data');
      }
      throw new Error('Network error');
    });
}

export function updateBusinessOwner(data) {
  return apiClient
    .patch('/business-owner/update/', {
      name: data.name,
      phone_number: data.phone_number,
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update owner');
      }
      throw new Error('Network error');
    });
}

export function saveLocation(data) {
  return apiClient
    .post('/location/save/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to save location');
      }
      throw new Error('Network error');
    });
}

export function saveBusiness(data) {
  return apiClient
    .post('/business/save/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to save business');
      }
      throw new Error('Network error');
    });
}

export function updateBusinessCategories(data) {
  return apiClient
    .post('/business/categories/update/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update categories');
      }
      throw new Error('Network error');
    });
}

export function updateBusinessWorkingHours(data) {
  return apiClient
    .post('/business/working-hours/update/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update working hours');
      }
      throw new Error('Network error');
    });
}

export function updateBusinessProfileCompleted(data) {
  return apiClient
    .patch('/business/profile-completed/update/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update profile completed');
      }
      throw new Error('Network error');
    });
}

export function updateBusinessActiveStatus(data) {
  return apiClient
    .patch('/business/update-active/', data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to update business status');
      }
      throw new Error('Network error');
    });
}

export function getComplexesAndCitiesLookup() {
  return apiClient
    .get('/lookup/complexes-cities/')
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch complexes and cities'
        );
      }
      throw new Error('Network error');
    });
}

export function getCategoriesMasterLookup() {
  return apiClient
    .get('/lookups/categories/')
    .then((response) => response.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch categories'
        );
      }
      throw new Error('Network error');
    });
}